import layout from './components/layout'
import subMenu from './components/subMenu'
import search from './components/search'
import footer from './components/footer'
import goToTop from './components/goToTop'
import modal from './components/modal'
import copyToClipboard from './utils/copyToClipboard'
import shareSocial from './components/shareSocial'
import milestone from './components/milestone'
import { externalNotice, onShareExternalNotice } from './components/externalNotice'

window.hsvmJQuery = $
window.copyToClipboard = copyToClipboard
window.onShareExternalNotice = onShareExternalNotice

layout()
subMenu()
search()
footer()
goToTop()
modal()
shareSocial()
externalNotice()
milestone()